import { Redirect } from 'expo-router';
import React from 'react';

export default function OnboardingRedirectPage() {
  return <Redirect href="/onboarding" />;
}
